import { SignInPage } from "Auth/Pages/SignInPage";
import { ConfigurationsPage } from "Configurations/Pages/ConfigurationsPage";
import { ConnectorConfigurationsPage } from "ConnectorConfigurations/Pages/ConnectorConfigurationsPage";
import { ExtractionsPage } from "Extractions/Pages/ExtractionsPage";
import { Error403Page } from "Infrastructure/Pages/Error403Page";
import { Error404Page } from "Infrastructure/Pages/Error404Page";
import { AuthenticatedRoute } from "Infrastructure/Routing/AuthenticatedRoute";
import { RoleProtectedRoute } from "Infrastructure/Routing/RoleProtectedRoute";
import { UnauthenticatedRoute } from "Infrastructure/Routing/UnauthenticatedRoute";
import { AppRouting, getRoute } from "Infrastructure/Utils/UrlUtils";
import { TenantsPage } from "Tenants/Pages/TenantsPage";
import { TestPage } from "Test/Pages/TestPage";
import { UsersPage } from "Users/Pages/UsersPage";
import { createBrowserRouter } from "react-router-dom";

const appRoutes = [
	{
		path: getRoute(AppRouting.SignIn),
		element: (
			<UnauthenticatedRoute>
				<SignInPage />
			</UnauthenticatedRoute>
		),
	},
	{
		path: getRoute(AppRouting.Configurations),
		element: (
			<AuthenticatedRoute>
				<ConfigurationsPage />
			</AuthenticatedRoute>
		),
	},
	{
		path: getRoute(AppRouting.ConnectorConfigurations),
		element: (
			<RoleProtectedRoute requiredAccessRights={["Tenants"]}>
				<ConnectorConfigurationsPage />
			</RoleProtectedRoute>
		),
	},
	{
		path: getRoute(AppRouting.Test),
		element: (
			<AuthenticatedRoute>
				<TestPage />
			</AuthenticatedRoute>
		),
	},
	{
		path: getRoute(AppRouting.Tenants),
		element: (
			<RoleProtectedRoute requiredAccessRights={["Tenants"]}>
				<TenantsPage />
			</RoleProtectedRoute>
		),
	},
	{
		path: getRoute(AppRouting.Extractions),
		element: (
			<RoleProtectedRoute requiredAccessRights={["Tenants"]}>
				<ExtractionsPage />
			</RoleProtectedRoute>
		),
	},
	{
		path: getRoute(AppRouting.Users),
		element: (
			<RoleProtectedRoute requiredAccessRights={["Tenants"]}>
				<UsersPage />
			</RoleProtectedRoute>
		),
	},
	{
		path: getRoute(AppRouting.Error403),
		element: <Error403Page />,
	},
	{
		path: "*",
		element: <Error404Page />,
	},
];

export const appRouter = createBrowserRouter(appRoutes, {
	basename: import.meta.env.VITE_BASE_URL,
});
